import { useSnapshot } from 'valtio'
import { voiceEventMarker } from '../voiceEventMarker'

export function useVisibleVoiceEventMarkerId() {
  return useSnapshot(voiceEventMarker).event?.id
}
